/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

import { IMAGE_FRAGMENT, IMAGE_SET_FRAGMENT } from './images';
import { LOCATION_FRAGMENT } from './locations';
import { SPONSOR_FRAGMENT } from './sponsors';

export const EVENT_FRAGMENT = gql`
  fragment event on EventNode {
    id
    description
    discloseSharedMarketing
    discloseSharedMarketingLabel
    displayCountdown
    displayLocation
    displayMission
    imageTreatment
    missionCopy
    missionTitle
    name
    slug
    status
    subtitle
  }
`;

export const EVENT_DATE_FRAGMENT = gql`
  fragment eventDate on EventDateNode {
    id
    date
    description
    gcalUrl
    isAllDay
    isRegistrationClosed
    isTimeEndSuppressed
    rsvpType
    registrationUrl
    timeEnd
    timeStart
    timeStartLocal
    url
  }
`;

export const EVENT_QUERY = gql`
  ${EVENT_FRAGMENT}
  ${EVENT_DATE_FRAGMENT}
  ${IMAGE_FRAGMENT}
  ${IMAGE_SET_FRAGMENT}
  ${LOCATION_FRAGMENT}
  ${SPONSOR_FRAGMENT}
  query Event($marketSlug: String, $slug: String) {
    event(marketSlug: $marketSlug, slug: $slug) {
      ...event
      dates {
        edges {
          node {
            ...eventDate
            imageSets {
              ...imageSet
            }
            locations {
              ...location
            }
            sponsors {
              ...sponsor
            }
            rsvps {
              id
              status
            }
          }
        }
      }
      category {
        id
        image {
          ...image
        }
      }
      image {
        ...image
      }
      imageSets {
        ...imageSet
      }
      locations {
        ...location
      }
      market {
        id
        shortName
      }
      sponsors {
        ...sponsor
      }
    }
    mission {
      title
      copy
    }
  }
`;

export const RSVP_MUTATION = gql`
  mutation RSVP($id: ID!, $status: RSVPStatus) {
    rsvp(eventDate: $id, status: $status) {
      errors
      rsvp {
        id
        status
      }
    }
  }
`;
